import { Store } from 'src/store/index';

const getFrameUpsellData = (store: Store) => store.upsell.frameUpsellPopupData;
export default getFrameUpsellData;
